import { useService } from '@visiba/instantiation';
import { Fragment, ReactNode } from 'react';
import { LiveAnnouncerController } from './live_announcer.controller';

interface Props {
	children: ReactNode;
}

export function LiveAnnouncerProvider({ children }: Props): JSX.Element {
	// We're doing it this way, with the initialization, just to prepare the DOM elements.
	useService(LiveAnnouncerController);

	return <Fragment>{children}</Fragment>;
}
